import axios from 'axios';

const pluginbot_api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

export default pluginbot_api;
